import { exportHtml, exportProject, type HtmlExportOpts, DEFAULT_HTML_OPTS } from './projectFile';

export class ExportModal {
  private bg!: HTMLElement;
  private opts: HtmlExportOpts = { ...DEFAULT_HTML_OPTS };

  constructor() {
    this.build();
  }

  private build(): void {
    this.bg = document.createElement('div');
    this.bg.className = 'modal-bg';
    const modal = document.createElement('div');
    modal.className = 'modal';

    const h = document.createElement('h3');
    h.textContent = '내보내기';

    const desc = document.createElement('p');
    desc.textContent =
      '두 가지 형식. .float 은 Float:Flash-html5에서 다시 열 수 있는 소스 파일이고, HTML 은 누구나 더블클릭해서 바로 볼 수 있는 페이지예요.';

    // ─── .float card ───
    const floatCard = document.createElement('div');
    floatCard.className = 'export-card';
    const floatTitle = document.createElement('h4');
    floatTitle.textContent = '🅵 .float 프로젝트 파일';
    const floatDesc = document.createElement('p');
    floatDesc.textContent =
      '레이어/스크립트/오디오 등 모든 데이터가 들어있는 단일 파일. 다시 불러오기로 그대로 편집 가능.';
    const floatBtn = document.createElement('button');
    floatBtn.className = 'btn primary';
    floatBtn.textContent = '.float 다운로드';
    floatBtn.addEventListener('click', () => {
      exportProject();
    });
    floatCard.append(floatTitle, floatDesc, floatBtn);

    // ─── HTML card ───
    const htmlCard = document.createElement('div');
    htmlCard.className = 'export-card';
    const htmlTitle = document.createElement('h4');
    htmlTitle.textContent = '🅷 HTML 페이지';
    const htmlDesc = document.createElement('p');
    htmlDesc.textContent =
      '한 번 더블클릭하면 그대로 재생되는 페이지. 옵션으로 자동재생/반복/컨트롤바 등을 켜고 끌 수 있어요.';

    const optionsGrid = document.createElement('div');
    optionsGrid.className = 'export-options';
    optionsGrid.append(
      this.toggle('자동 재생', 'autoplay'),
      this.toggle('반복 재생', 'loop'),
      this.toggle('컨트롤바', 'controls'),
      this.toggle('클릭하면 재생/정지', 'clickToPlay'),
    );

    const volRow = document.createElement('label');
    volRow.className = 'export-vol';
    volRow.textContent = '볼륨';
    const vol = document.createElement('input');
    vol.type = 'range';
    vol.min = '0';
    vol.max = '100';
    vol.value = String(Math.round(this.opts.volume * 100));
    vol.addEventListener('input', () => {
      this.opts.volume = parseInt(vol.value, 10) / 100;
    });
    volRow.appendChild(vol);
    optionsGrid.appendChild(volRow);

    const htmlBtn = document.createElement('button');
    htmlBtn.className = 'btn primary';
    htmlBtn.textContent = 'HTML 다운로드';
    htmlBtn.addEventListener('click', () => {
      exportHtml(this.opts);
    });

    const htmlNote = document.createElement('p');
    htmlNote.style.fontSize = '11px';
    htmlNote.style.color = 'var(--ink-dim)';
    htmlNote.textContent =
      '* 더 세밀한 제어가 필요하면 ⓢ 스크립트에서 글로벌 JS로 onTick 훅을 만들어요.';

    htmlCard.append(htmlTitle, htmlDesc, optionsGrid, htmlBtn, htmlNote);

    const actions = document.createElement('div');
    actions.className = 'row-actions';
    const close = document.createElement('button');
    close.className = 'btn';
    close.textContent = '닫기';
    close.addEventListener('click', () => this.close());
    actions.appendChild(close);

    modal.append(h, desc, floatCard, htmlCard, actions);
    this.bg.appendChild(modal);
    this.bg.addEventListener('click', (e) => {
      if (e.target === this.bg) this.close();
    });
    document.body.appendChild(this.bg);
  }

  private toggle(label: string, key: keyof HtmlExportOpts): HTMLElement {
    const wrap = document.createElement('label');
    wrap.className = 'export-toggle';
    const cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.checked = !!this.opts[key];
    cb.addEventListener('change', () => {
      (this.opts as unknown as Record<string, unknown>)[key] = cb.checked;
    });
    const text = document.createElement('span');
    text.textContent = label;
    wrap.append(cb, text);
    return wrap;
  }

  open(): void {
    this.bg.classList.add('show');
  }
  close(): void {
    this.bg.classList.remove('show');
  }
}
